export interface EventType {
    ClientKey?: string;
    Id: string;
    EventTypeName: string;
}